/**
 * Test Home Page
 * Temporary page to test the shared PageLayout
 */

import React from 'react';
import PageLayout from '../components/PageLayout';
import {
  SLAPanel,
  HealthPanel,
  ProfileInfoPanel,
} from '../components/dashboard';
import styles from './TestHome.module.css';

const TestHome: React.FC = () => {
  return (
    <PageLayout>
      <div className={styles.dashboardGrid}>
        {/* Demo Dashboard Panels */}
        <SLAPanel
          met={95}
          metCount={19}
          missedCount={1}
        />
        <HealthPanel
          totalResources={100}
          critical={2}
          warning={5}
          neutral={10}
          good={83}
        />
        <ProfileInfoPanel
          firstName="John"
          lastName="Smith"
          email="john.smith@commvault.com"
          phone="+1 555-555-1234"
          address="123 Main St, City, State 12345"
          role="IT Administrator"
        />
      </div>
    </PageLayout>
  );
};

export default TestHome;
